import { create } from 'zustand';

type Severity = 'success' | 'info' | 'warning' | 'error';

type NotificationType = {
  open: boolean, delayTime?: number | null, type?: Severity, msg?: string
}

const DEFAULT_DELAY_TIME = 5000;

interface NotificationState {
  open: boolean;
  delayTime?: number | null;
  msg?: string;
  type: Severity;
  triggerNotification: (data: NotificationType) => void;
  destroyNotification: (open: boolean) => void;
}

export const notificationStore = create<NotificationState>()(set => ({
  open: false,
  type: 'success',
  triggerNotification: ({ open, delayTime = DEFAULT_DELAY_TIME, type, msg }: NotificationType) =>
    set({ open, delayTime, type, msg }),
  destroyNotification: () => set({ open: false }),
}));
